export function applyFastBundleOrder(list) {
  const children = Array.from(list.children);
  const buyButtonIndex = children.findIndex(
    (child) =>
      child.dataset.blockType === 'buy-buttons' &&
      child.querySelector('[id^="rbr-container-element"]')
  );
  if (buyButtonIndex === -1) return false;

  list.style.display = '';
  list.style.flexDirection = '';
  children.forEach((child) => {
    child.style.order = '';
  });

  list.style.display = 'flex';
  list.style.flexDirection = 'column';

  children.forEach((child, index) => {
    child.style.order = String(index * 10);
  });

  children[buyButtonIndex].style.order = String(children.length * 10);
  return true;
}

export function syncFastBundleOrder(root = document) {
  root.querySelectorAll('.product-info__block-list').forEach((list) => {
    applyFastBundleOrder(list);
  });
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  let scheduled = false;
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;

    queueMicrotask(() => {
      scheduled = false;
      syncFastBundleOrder();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
